import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noida',
  templateUrl: './noida.component.html',
  styleUrls: ['./noida.component.scss']
})
export class NoidaComponent implements OnInit {

  constructor() { }
  numb: any = [
    {
      n:'1',
      xy:'182px 0 0 46px'
    },
    {
      n:'2',
      xy:'182px 0 0 55px'
    },
    {
      n:'3',
      xy:'182px 0 0 190px'
    },
    {
      n:'4',
      xy:'182px 0 0 24px'
    },
    {
      n:'5',
      xy:'182px 0 0 38px'
    },
    {
      n:'6',
      xy:'182px 50px 0 24px'
    },
    {
      n:'7',
      xy:'9px 0 0 46px'
    },
    {
      n:'8',
      xy:'9px 410px 0 55px'
    },
    {
      n:'9',
      xy:'9px 0 0 46px'
    },
    {
      n:'10',
      xy:'9px 0 0 55px'
    },
    {
      n:'11',
      xy:'-26px 0 0 190px'
    },
    {
      n:'12',
      xy:'-26px 0 0 24px'
    },
    {
      n:'13',
      xy:'-26px 0 0 38px'
    },
    {
      n:'14',
      xy:'-26px 50px 0 22px'
    },
    {
      n:'15',
      xy:'6px 0 0 46px'
    },
    {
      n:'16',
      xy:'6px 400px 0 55px'
    },
    {
      n:'17',
      xy:'6px 0 0 46px'
    },
    {
      n:'18',
      xy:'6px 360px 0 55px'
    },
    {
      n:'19',
      xy:'-10px 0 0 240px'
    },
    {
      n:'20',
      xy:'-10px 100px 0 9px'
    },
    {
      n:'21',
      xy:'19px 0 0 335px'
    },
    {
      n:'22',
      xy:'19px 0 0 24px'
    },
    {
      n:'23',
      xy:'19px 0 0 38px'
    },
    {
      n:'24',
      xy:'19px 50px 0 24px'
    },
    {
      n:'25',
      xy:'19px 0 0 335px'
    },
    {
      n:'26',
      xy:'19px 0 0 24px'
    },
    {
      n:'27',
      xy:'19px 0 0 38px'
    },
    {
      n:'28',
      xy:'19px 50px 0 24px'
    },
    {
      n:'29',
      xy:'-6px 0 0 30px'
    },
    {
      n:'30',
      xy:'-6px 0 0 30px'
    },
    {
      n:'31',
      xy:'-6px 0 0 24px'
    },
    {
      n:'32',
      xy:'45px 0 0 81px'
    },
    {
      n:'33',
      xy:'45px 0 0 24px'
    },
    {
      n:'34',
      xy:'28px 0 0 36px'
    },
    {
      n:'35',
      xy:'28px 0 0 28px'
    },
    {
      n:'36',
      xy:'28px 0 0 30px'
    },
    {
      n:'37',
      xy:'28px 50px 0 28px'
    },
    {
      n:'38',
      xy:'26px 0 0 30px'
    },
    {
      n:'39',
      xy:'26px 0 0 30px'
    },
    {
      n:'40',
      xy:'26px 0 0 24px'
    },
    {
      n:'41',
      xy:'11px 0 0 81px'
    },
    {
      n:'42',
      xy:'11px 0 0 24px'
    },
    {
      n:'43',
      xy:'26px 0 0 36px'
    },
    {
      n:'44',
      xy:'26px 0 0 26px'
    },
    {
      n:'45',
      xy:'26px 0 0 30px'
    },
    {
      n:'46',
      xy:'26px 50px 0 28px'
    },
    {
      n:'47',
      xy:'6px 0 0 30px'
    },
    {
      n:'48',
      xy:'6px 0 0 30px'
    },
    {
      n:'49',
      xy:'6px 0 0 24px'
    },
    {
      n:'50',
      xy:'42px 0 0 81px'
    },
    {
      n:'51',
      xy:'42px 0 0 24px'
    },
    {
      n:'52',
      xy:'51px 0 0 36px'
    },
    {
      n:'53',
      xy:'51px 0 0 28px'
    },
    {
      n:'54',
      xy:'51px 0 0 30px'
    },
    {
      n:'55',
      xy:'51px 50px 0 28px'
    },
    {
      n:'56',
      xy:'26px 0 0 30px'
    },
    {
      n:'57',
      xy:'26px 0 0 30px'
    },
    {
      n:'58',
      xy:'26px 0 0 24px'
    },
    {
      n:'59',
      xy:'-2px 0 0 81px'
    },
    {
      n:'60',
      xy:'-2px 0 0 24px'
    },
    {
      n:'61',
      xy:'36px 0 0 36px'
    },
    {
      n:'62',
      xy:'36px 0 0 26px'
    },
    {
      n:'63',
      xy:'36px 0 0 30px'
    },
    {
      n:'64',
      xy:'36px 50px 0 28px'
    },
    {
      n:'65',
      xy:'-8px 0 0 30px'
    },
    {
      n:'66',
      xy:'-8px 0 0 30px'
    },
    {
      n:'67',
      xy:'-8px 0 0 24px'
    },
    {
      n:'68',
      xy:'24px 0 0 81px'
    },
    {
      n:'69',
      xy:'24px 0 0 24px'
    },
    {
      n:'70',
      xy:'51px 0 0 36px'
    },
    {
      n:'71',
      xy:'51px 0 0 28px'
    },
    {
      n:'72',
      xy:'51px 0 0 30px'
    },
    {
      n:'73',
      xy:'51px 50px 0 28px'
    },
    {
      n:'74',
      xy:'-32px 0 0 105px'
    },
    {
      n:'75',
      xy:'-32px 0 0 7px'
    },
    {
      n:'76',
      xy:'-22px 0 0 75px'
    },
    {
      n:'77',
      xy:'-22px 0 0 24px'
    },
    {
      n:'78',
      xy:'36px 0 0 36px'
    },
    {
      n:'79',
      xy:'36px 0 0 28px'
    },
    {
      n:'80',
      xy:'36px 0 0 30px'
    },
    {
      n:'81',
      xy:'36px 50px 0 28px'
    },
    {
      n:'82',
      xy:'36px 0 0 107px'
    },
    {
      n:'83',
      xy:'36px 405px 0 5px'
    },
    {
      n:'84',
      xy:'32px 0 0 354px'
    },
    {
      n:'85',
      xy:'32px 0 0 12px'
    },
    {
      n:'86',
      xy:'32px 0 0 90px'
    },
    {
      n:'87',
      xy:'32px 0 0 12px'
    },
    {
      n:'88',
      xy:'9px 0 0 334px'
    },
    {
      n:'89',
      xy:'9px 0 0 50px'
    },
    {
      n:'90',
      xy:'9px 0 0 52px'
    },
    {
      n:'91',
      xy:'9px 0 0 50px'
    },
    {
      n:'92',
      xy:'9px 0 0 354px'
    },
    {
      n:'93',
      xy:'9px 0 0 12px'
    },
    {
      n:'94',
      xy:'9px 0 0 90px'
    },
    {
      n:'95',
      xy:'9px 0 0 12px'
    }
    
  ]

  ngOnInit(): void {
  }

}
